var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"all-users"},[_c('users-list-table',{attrs:{"users":_vm.users,"meta":_vm.listMeta,"links":_vm.listLinks,"loading":_vm.loading},on:{"loadMore":_vm.loadMore}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }